/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import InfinityLoader from '@/components/common/infinityLoader'
import { EventDetailsOutputQuery } from '@/types/graphql/types'
import {
  CheckIcon,
  ClockIcon,
  ExclamationIcon,
  XIcon,
} from '@heroicons/react/outline'
import { Button, Loader, Select, Text } from '@mantine/core'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import {
  BOOKING_STATUS,
  EVENT_TYPE,
  METHOD_OF_DELIVERY,
  PRICING_PLAN_TYPE,
  ROLE,
} from 'db'
import { isArray, parseInt } from 'lodash'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { BsLinkedin, BsTelegram, BsWhatsapp } from 'react-icons/bs'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share'
import useEventPricing from '@/hooks/client/Event/useEventPricing'
import { useSession } from 'next-auth/react'

require('dayjs/locale/ar')

dayjs.extend(relativeTime)

const toHashtag = (str: string) =>
  (str || '')
    .toLocaleLowerCase()
    .replace(/\s/g, '_')
    .replace(/[^a-zA-Z0-9_]/g, '')

const EventPagePricing = ({
  event,
}: {
  event: EventDetailsOutputQuery['EventDetailsOutput']
}) => {
  const { t, lang } = useTranslation('client')
  const router = useRouter()
  const { data: userData } = useSession()
  const isArabic = lang === 'ar'

  const {
    loading,
    loadingBuyCertificate,
    isLoggedIn,
    form,
    price,
    showGroupData,
    totalToPayWithoutTax,
    usedWalletBallance,
    workshopPrice,
    containsWorkshop,
    setHideAlreadyBookedMessage,
    hasBookingData,
    isCertificateAndCMEText,
    isFree,
    locale,
    certificatePrice,
    errorAlreadyRegistredMemebers,
    bookingStatusId,
    noSeatsAvailableError,
    openGroupModal,
    remindMe,
    remindmeLoading,
    errorMessage,
    hideAlreadyBookedMessage,
    ref,
    isCoursePaid,
    error,
    refTemp,
    expiredGroupDiscount,
    groupDiscountMessage,
    groupDiscountMessageWithHastag,
    shareLink,
    priceData,
    buyCertificate,
    shouldShowBuyCertificate,
    isCertificateFreeText,
  } = useEventPricing({ event })

  return (
    <div
      className="relative px-4 py-8 rounded-3xl"
      style={
        error
          ? {}
          : {
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3E%3Cpath fill='%23164e63' fill-opacity='0.24' d='M1 3h1v1H1V3zm2-2h1v1H3V1z'%3E%3C/path%3E%3C/svg%3E")`,
            }
      }
    >
      {typeof bookingStatusId !== 'undefined' &&
      ![BOOKING_STATUS.refunded.id, BOOKING_STATUS.cancled.id].includes(
        bookingStatusId,
      ) &&
      !hideAlreadyBookedMessage ? (
        <div>
          <Text size="xl" weight={700} color="gray">
            {t('youAlreadyBookedMessage')}
          </Text>
          <div className="pt-4">
            {[BOOKING_STATUS.paid.id, BOOKING_STATUS.guest.id].includes(
              bookingStatusId,
            ) && (
              <div>
                <p className="pb-2">{t('bookingConfirmed')}</p>
                <div className="flex gap-2">
                  <Button>
                    <Link
                      href={
                        event.eventType?.id === EVENT_TYPE.asynchronous.id
                          ? `/bookings/${hasBookingData?.findUniqueTraineeEvent?.id}?t=course`
                          : `/bookings/${hasBookingData?.findUniqueTraineeEvent?.id}?t=schedule`
                      }
                    >
                      <a>{t('viewBooking')}</a>
                    </Link>
                  </Button>

                  {shouldShowBuyCertificate && (
                    <Button
                      disabled={loadingBuyCertificate}
                      variant="outline"
                      loading={loadingBuyCertificate}
                      color="cyan"
                      onClick={() => buyCertificate()}
                    >
                      {t('buyCertificate')}
                    </Button>
                  )}
                </div>
              </div>
            )}
            {bookingStatusId === BOOKING_STATUS.unpaid.id && (
              <div>
                <p className="pb-2">{t('bookingNotPaid')}</p>
                <div className="flex gap-2">
                  <Button>
                    <Link
                      href={`/payment/${event.id}?bookingId=${
                        hasBookingData?.findUniqueTraineeEvent?.id
                      }&ref=${ref || refTemp}`}
                    >
                      <a>{t('continuePayment')}</a>
                    </Link>
                  </Button>
                  <Button
                    variant="outline"
                    onClick={() => setHideAlreadyBookedMessage(true)}
                  >
                    <a>{t('updateBooking')}</a>
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : error ? (
        <>
          <div className="rounded-md bg-yellow-50 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <ExclamationIcon
                  className="h-5 w-5 text-yellow-400"
                  aria-hidden="true"
                />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-yellow-800">
                  {t(errorMessage)}
                </h3>

                <ul>
                  {errorAlreadyRegistredMemebers?.map(e => (
                    <li className="text-sm text-yellow-700">{e}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="pt-2">
            <Button variant="light" onClick={() => form.reset()}>
              {t('ok')}
            </Button>
          </div>
        </>
      ) : isLoggedIn ? (
        loading ? (
          <div className="flex justify-center items-center">
            <InfinityLoader variant="md" />
          </div>
        ) : (
          <div>
            <div className="">
              <h2 className="sr-only">Price</h2>
              <p className="">
                <span className="flex flex-col text-center">
                  {/* <span className="text-5xl font-extrabold text-secondary tracking-tight">
                    {isFree
                      ? t('free')
                      : isArabic
                      ? `${totalToPayWithoutTax} رس`
                      : `${totalToPayWithoutTax} SR`}
                  </span> */}
                  {event?.pricingPlan?.hasDiscount &&
                  (!event?.pricingPlan.hasDiscountEndDate ||
                    dayjs(event?.pricingPlan.discountEndDate).isAfter(
                      new Date(),
                    )) ? (
                    <span>
                      {event.pricingPlan.discountPercentage ? (
                        <div className="flex flex-col gap-1 items-center align-center justify-center">
                          <div>
                            <span className="text-4xl font-extrabold text-secondary  tracking-tight">
                              {event.price} SR
                            </span>
                          </div>
                          <div>
                            <span className="line-through text-red-500 text-2xl ml-2  text-secondary tracking-tight">
                              {(
                                Number(event.price) +
                                (Number(event.price) *
                                  event.pricingPlan.discountPercentage) /
                                  100
                              ).toFixed(2)}{' '}
                              SR
                            </span>

                            <span className="text-gray-500 font-bold ml-2 text-2xl   tracking-tight">
                              {event.pricingPlan.discountPercentage}% OFF
                            </span>
                          </div>
                          {event.pricingPlan.hasDiscountEndDate && (
                            <div className="flex items-center gap-2">
                              <ClockIcon width={15} height={15} color="red" />
                              <span className="text-red-500 text-lg font-bold">
                                {dayjs(event.pricingPlan.discountEndDate).diff(
                                  dayjs(),
                                  'day',
                                )}{' '}
                                days{' '}
                                <span className="font-medium">
                                  {' '}
                                  left at this price!
                                </span>
                              </span>
                            </div>
                          )}
                        </div>
                      ) : (
                        <span className="text-5xl font-extrabold text-secondary tracking-tight">
                          {event.price} SR
                        </span>
                      )}
                    </span>
                  ) : (
                    <span className="text-5xl font-extrabold text-secondary tracking-tight">
                      {isFree
                        ? t('free')
                        : isArabic
                        ? `${totalToPayWithoutTax} رس`
                        : `${totalToPayWithoutTax} SR`}
                    </span>
                  )}
                </span>
              </p>
            </div>

            {!isFree && (
              <p className="mt-8  text-base font-medium text-gray-500">
                {t('customizeYourBooking')}
              </p>
            )}

            <ul
              role="list"
              className="rounded overflow-hidden grid gap-2 sm:grid-cols-1 mt-2"
            >
              {showGroupData && (
                <li
                  className="bg-cyan-50 hover:bg-cyan-100 border border-transparent text-secondary py-4 px-4 flex items-start justify-between space-x-3 text-base cursor-pointer shadow-sm"
                  onClick={() => form.reset()}
                >
                  <span className="flex gap-1">
                    {form.values.isGroupRegistrant ? (
                      <CheckIcon
                        className="h-6 w-6 text-cyan-300"
                        aria-hidden="true"
                      />
                    ) : (
                      <XIcon
                        className="h-6 w-6 text-red-300"
                        aria-hidden="true"
                      />
                    )}
                    <span>
                      {t('groupRegistration')}
                      {` (
                      ${priceData?.getCoursePrice.traineeEventGroup?.traineeEvents.length}
                      )`}
                    </span>
                  </span>
                  <span className="min-w-fit">
                    {isArabic
                      ? `${totalToPayWithoutTax} رس`
                      : `${totalToPayWithoutTax} SR`}
                  </span>
                </li>
              )}
              {containsWorkshop && (
                <li
                  className="bg-cyan-50 hover:bg-cyan-100 border border-transparent text-secondary py-4 px-4 flex items-start justify-between space-x-3 text-base cursor-pointer shadow-sm"
                  onClick={() => {
                    if (form.values.isGroupRegistrant) return
                    form.setFieldValue('workshop', !form.values.workshop)
                  }}
                >
                  <span className="flex gap-1">
                    {form.values.workshop ? (
                      <CheckIcon
                        className="h-6 w-6 text-cyan-300"
                        aria-hidden="true"
                      />
                    ) : (
                      <XIcon
                        className="h-6 w-6 text-red-300"
                        aria-hidden="true"
                      />
                    )}
                    <span>{t('registerFor', { x: t('workshop') })}</span>
                  </span>
                  {form.values.workshop && workshopPrice > 0 && (
                    <span className="min-w-fit">
                      {isArabic ? `${workshopPrice} رس` : `${workshopPrice} SR`}
                    </span>
                  )}
                </li>
              )}
              {event.pricingPlan?.pricingPlanType?.id ===
                PRICING_PLAN_TYPE.multiPartProgram.id && showGroupData ? (
                <li className="bg-cyan-50 hover:bg-cyan-100 border border-transparent text-secondary py-4 px-4 flex items-start justify-between space-x-3 text-base cursor-pointer shadow-sm">
                  <span className="flex gap-1">
                    <CheckIcon
                      className="h-6 w-6 text-cyan-300"
                      aria-hidden="true"
                    />
                    <span>{t('registerForAllParts')}</span>
                  </span>
                </li>
              ) : (
                event.pricingPlan?.pricingPlanType?.id ===
                  PRICING_PLAN_TYPE.multiPartProgram.id &&
                isArray(price?.parts) &&
                (price?.parts as any[]).length > 0 &&
                event.eventParts?.map(part => {
                  const selectedPart =
                    price?.parts?.find(e => e.eventPartId === part?.id) ||
                    price?.isGroupRegistrant
                  const partPrice = price?.parts?.find(
                    p => p.eventPartId === part?.id,
                  )?.partTotalPrice
                  return (
                    <li
                      key={part?.id}
                      className="bg-cyan-50 hover:bg-cyan-100 border border-transparent text-secondary py-4 px-4 flex items-start justify-between space-x-3 text-base cursor-pointer shadow-sm"
                      onClick={() => {
                        if (form.values.parts?.includes(part!.id))
                          form.setFieldValue(
                            'parts',
                            form.values.parts?.filter(p => p !== part?.id),
                          )
                        else
                          form.setFieldValue('parts', [
                            ...form.values.parts,
                            part!.id,
                          ])
                      }}
                    >
                      <span className="flex gap-1">
                        {selectedPart ? (
                          <CheckIcon
                            className="h-6 w-6 text-cyan-300"
                            aria-hidden="true"
                          />
                        ) : (
                          <XIcon
                            className="h-6 w-6 text-red-300"
                            aria-hidden="true"
                          />
                        )}
                        <span>
                          {t('registerFor', {
                            x: isArabic ? part?.outlineAr : part?.outlineEn,
                          })}
                        </span>
                      </span>
                      {partPrice > 0 && (
                        <span className="min-w-fit">
                          {isArabic ? `${partPrice} رس` : `${partPrice} SR`}
                        </span>
                      )}
                    </li>
                  )
                })
              )}

              {usedWalletBallance > 0 && (
                <li className="bg-cyan-50 hover:bg-cyan-100 border border-transparent text-secondary py-4 px-4 flex items-start justify-between space-x-3 text-base cursor-pointer shadow-sm">
                  <span className="flex gap-1">
                    <CheckIcon
                      className="h-6 w-6 text-cyan-300"
                      aria-hidden="true"
                    />
                    <span>{t('walletBalance')}</span>
                  </span>

                  <span className="min-w-fit">
                    -{' '}
                    {isArabic
                      ? `${usedWalletBallance} رس`
                      : `${usedWalletBallance} SR`}
                  </span>
                </li>
              )}
              {!isFree ? (
                <div
                  className={`relative rounded-lg p-[3px] ${
                    isCoursePaid ? '' : 'bg-animation'
                  }`}
                >
                  <li
                    className="bg-cyan-50 hover:bg-cyan-100 border border-transparent text-secondary py-4 px-4 flex items-start justify-between space-x-3 text-base cursor-pointer relative rounded-lg
                   "
                    onClick={() => {
                      //event.pricingPlan.freePlanCertificateCmeIsPaid
                      if (
                        form.values.isGroupRegistrant ||
                        !(
                          event.pricingPlan?.pricingPlanType?.id ===
                            PRICING_PLAN_TYPE.free.id &&
                          [
                            'certificateAndCMEIsPaid',
                            'certificateIsPaid',
                          ].includes(
                            event.pricingPlan?.freePlanCertificateStatus ??
                              'justRegister',
                          )
                        )
                      )
                        return
                      form.setFieldValue(
                        'isCertificateRegistrant',
                        !form.values.isCertificateRegistrant,
                      )
                    }}
                  >
                    <span className="flex gap-1">
                      {form.values.isCertificateRegistrant ? (
                        <CheckIcon
                          className="h-6 w-6 text-cyan-300"
                          aria-hidden="true"
                        />
                      ) : (
                        <XIcon
                          className="h-6 w-6 text-red-300"
                          aria-hidden="true"
                        />
                      )}
                      <span>
                        {isCertificateAndCMEText
                          ? t('certificateAndCMEisPaid')
                          : t('certificatePrice')}
                      </span>
                    </span>
                    {form.values.isCertificateRegistrant &&
                      certificatePrice > 0 && (
                        <span className="min-w-fit">
                          {isArabic
                            ? `${certificatePrice} رس`
                            : `${certificatePrice} SR`}
                        </span>
                      )}
                  </li>
                </div>
              ) : isFree &&
                (isCertificateAndCMEText || isCertificateFreeText) ? (
                <div
                  className={`relative rounded-lg p-[3px] ${
                    isCoursePaid ? '' : 'bg-animation'
                  }`}
                >
                  <li
                    className="bg-cyan-50 hover:bg-cyan-100 border border-transparent text-secondary py-4 px-4 flex items-start justify-between space-x-3 text-base cursor-pointer relative rounded-lg
               "
                    // onClick={() => {
                    //   //event.pricingPlan.freePlanCertificateCmeIsPaid
                    //   if (
                    //     form.values.isGroupRegistrant ||
                    //     !(
                    //       event.pricingPlan?.pricingPlanType?.id ===
                    //         PRICING_PLAN_TYPE.free.id &&
                    //       [
                    //         'certificateAndCMEIsPaid',
                    //         'certificateIsPaid',
                    //       ].includes(
                    //         event.pricingPlan?.freePlanCertificateStatus ??
                    //           'justRegister',
                    //       )
                    //     )
                    //   )
                    //     return
                    //   form.setFieldValue(
                    //     'isCertificateRegistrant',
                    //     !form.values.isCertificateRegistrant,
                    //   )
                    // }}
                  >
                    <span className="flex gap-1">
                      <CheckIcon
                        className="h-6 w-6 text-cyan-300"
                        aria-hidden="true"
                      />

                      <span>
                        {isCertificateAndCMEText
                          ? t('certificateAndCMEIsFree')
                          : t('certificateIsFree')}
                      </span>
                    </span>
                    {form.values.isCertificateRegistrant &&
                      certificatePrice > 0 && (
                        <span className="min-w-fit">
                          {isArabic
                            ? `${certificatePrice} رس`
                            : `${certificatePrice} SR`}
                        </span>
                      )}
                  </li>
                </div>
              ) : null}
            </ul>

            {event?.methodOfDelivery?.id ===
              METHOD_OF_DELIVERY.onsiteOrOnline.id && (
              <Select
                mt={10}
                required
                className="focus:ring-cyan-500 ring-cyan-500 focus:border-cyan-500 border-cyan-600"
                data={[
                  { value: 'ONLINE', label: t('online') },
                  { value: 'ONSITE', label: t('onsite') },
                ]}
                label={t('methodOfDelivery')}
                {...form.getInputProps('methodOfDelivery')}
              />
            )}

            <p className="text-red-600 text-center pt-4">
              {t(noSeatsAvailableError || ' ')}
            </p>
            {noSeatsAvailableError ? (
              <Button
                variant="outline"
                sx={{
                  width: '100%',
                  height: '3.5rem',
                  fontSize: '1.25rem',
                  fontWeight: 600,
                }}
                disabled={remindmeLoading}
                onClick={() => {
                  remindMe({
                    variables: {
                      data: { eventId: parseInt(router.query.id as string) },
                    },
                  })
                }}
              >
                {remindmeLoading ? <Loader /> : t('common:notifyMe')}
              </Button>
            ) : (
              <Button
                className="bg-gradient-to-r from-primary to-secondary mt-4 "
                sx={{
                  width: '100%',
                  height: '3.5rem',
                  fontSize: '1.25rem',
                  fontWeight: 600,
                }}
                onClick={() => {
                  const group = form.values.isGroupRegistrant ? 1 : 0
                  router.push({
                    pathname: `/payment/${event?.id}`,
                    query: {
                      workshop: form.values.workshop ? 1 : 0,
                      parts: form.values.parts.join(','),
                      mod: form.values.methodOfDelivery,
                      cert: form.values.isCertificateRegistrant ? 1 : 0,
                      group,
                      ...(group
                        ? {
                            emails: form.values.groupTraineeEmails.join(','),
                            groupPay: form.values.isGroupPay ? 1 : 0,
                          }
                        : {}),
                      ref: ref || refTemp,
                    },
                  })
                }}
                disabled={
                  !!noSeatsAvailableError ||
                  userData?.user.roleId !== ROLE.trainee.id
                }
              >
                {t('bookNow')}
              </Button>
            )}
            {/** Group Booking Btn */}
            {event.pricingPlan?.hasGroupDiscount && !expiredGroupDiscount && (
              <>
                <div className="w-full mt-1">
                  <Button
                    variant="gradient"
                    sx={{ width: '100%' }}
                    onClick={openGroupModal}
                    disabled={!!noSeatsAvailableError}
                    style={{
                      background:
                        'radial-gradient(circle, rgba(170,119,28,1) 0%, rgba(253,187,45,1) 100%)',
                    }}
                  >
                    <span className="font-bold text-lg">
                      {t('CreateGroupDiscount', {
                        x: event.pricingPlan
                          ?.groupDiscountMinNumberOfRegistrants,
                      })}
                    </span>
                  </Button>
                </div>
                {event.pricingPlan?.hasGroupDiscountEndDate && (
                  <span className="mt-1 block text-center text-sm font-medium text-red-500">
                    {t('groupDiscountExpiresIn')}{' '}
                    {isArabic
                      ? dayjs(event.pricingPlan?.groupDiscountEndDate)
                          .locale('ar')
                          .fromNow(true)
                      : dayjs(event.pricingPlan?.groupDiscountEndDate).fromNow(
                          true,
                        )}
                  </span>
                )}
                <div className=" border-gray-200 pt-4">
                  <h3 className="text-sm font-medium text-gray-900">
                    {t('findAGroup')}
                  </h3>
                  <ul role="list" className="flex items-center gap-4 mt-2">
                    <li>
                      <a
                        href="#"
                        className="flex items-center justify-center w-4 h-4 text-[#1773ea] hover:text-gray-500"
                      >
                        <span className="sr-only">Share on Facebook</span>
                        <FacebookShareButton
                          url={shareLink}
                          quote={groupDiscountMessageWithHastag}
                        >
                          <svg
                            className="w-5 h-5"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </FacebookShareButton>
                      </a>
                    </li>

                    <li>
                      <a
                        href="#"
                        className="flex items-center justify-center w-4 h-4 text-[#1c96e8] hover:text-gray-500"
                      >
                        <span className="sr-only">Share on Twitter</span>

                        <TwitterShareButton
                          url={shareLink}
                          title={groupDiscountMessageWithHastag}
                        >
                          <svg
                            className="w-5 h-5"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                          </svg>
                        </TwitterShareButton>
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="flex items-center justify-center w-4 h-4 text-[#32a6d8] hover:text-gray-500"
                      >
                        <span className="sr-only">Share on Telegram</span>

                        <TelegramShareButton
                          url={shareLink}
                          title={groupDiscountMessage}
                        >
                          <BsTelegram className="w-5 h-5" />
                        </TelegramShareButton>
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="flex items-center justify-center w-4 h-4 text-[#0a63bc] hover:text-gray-500"
                      >
                        <span className="sr-only">Share on LinkedIn</span>

                        <LinkedinShareButton
                          className="w-5 h-5"
                          url={shareLink}
                          title={groupDiscountMessageWithHastag}
                          summary={groupDiscountMessageWithHastag}
                          source={t('appName')}
                        >
                          <BsLinkedin className="w-5 h-5" />
                        </LinkedinShareButton>
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="flex items-center justify-center w-4 h-4 text-[#3fb154] hover:text-gray-500"
                      >
                        <span className="sr-only">Share on Whatsapp</span>

                        <WhatsappShareButton
                          className="w-5 h-5"
                          url={shareLink}
                          title={groupDiscountMessage}
                        >
                          <BsWhatsapp className="w-5 h-5" />
                        </WhatsappShareButton>
                      </a>
                    </li>
                  </ul>
                </div>
              </>
            )}
          </div>
        )
      ) : (
        <>
          <div>
            <h2 className="sr-only">Price</h2>
            <p className="">
              <span className="flex flex-col text-center">
                {/* <span className="text-5xl font-extrabold text-secondary tracking-tight">
                  {isArabic ? `${event?.price} رس` : `${event?.price} SR`}
                </span> */}
                {event?.pricingPlan?.hasDiscount &&
                (!event?.pricingPlan.hasDiscountEndDate ||
                  dayjs(event?.pricingPlan.discountEndDate).isAfter(
                    new Date(),
                  )) ? (
                  <span>
                    {event.pricingPlan.discountPercentage ? (
                      <div className="flex flex-col gap-1 items-center align-center justify-center">
                        <div>
                          <span className="text-4xl font-extrabold text-secondary  tracking-tight">
                            {event.price} SR
                          </span>
                        </div>
                        <div>
                          <span className="line-through text-red-500 text-2xl ml-2  text-secondary tracking-tight">
                            {(
                              Number(event.price) +
                              (Number(event.price) *
                                event.pricingPlan.discountPercentage) /
                                100
                            ).toFixed(2)}{' '}
                            SR
                          </span>

                          <span className="text-gray-500 font-bold ml-2 text-2xl   tracking-tight">
                            {event.pricingPlan.discountPercentage}% OFF
                          </span>
                        </div>
                        {event.pricingPlan.hasDiscountEndDate && (
                          <div className="flex items-center gap-2">
                            <ClockIcon width={15} height={15} color="red" />
                            <span className="text-red-500 text-lg font-bold">
                              {dayjs(event.pricingPlan.discountEndDate).diff(
                                dayjs(),
                                'day',
                              )}{' '}
                              days{' '}
                              <span className="font-medium">
                                {' '}
                                left at this price!
                              </span>
                            </span>
                          </div>
                        )}
                      </div>
                    ) : (
                      <span className="text-5xl font-extrabold text-secondary tracking-tight">
                        {event.price} SR
                      </span>
                    )}
                  </span>
                ) : (
                  <span className="text-5xl font-extrabold text-secondary tracking-tight">
                    {isFree || Number(event.price) === 0
                      ? t('free')
                      : isArabic
                      ? `${totalToPayWithoutTax} رس`
                      : `${totalToPayWithoutTax} SR`}
                  </span>
                )}
                <span className="mt-2 text-base font-medium text-gray-500">
                  {t('estimatedPrice')}
                </span>
              </span>
            </p>
          </div>
          <div className="flex flex-col gap-2">
            <button
              onClick={() =>
                router.push(
                  `${locale}/auth/signin?callbackUrl=${locale}${router.asPath}`,
                )
              }
              className="mt-4 bg-white w-full flex items-center justify-center leading-6 bg-gradient-to-r from-primary to-secondary bg-origin-border p-4 border border-transparent rounded-md shadow-sm text-base font-medium text-white drop-shadow-sm hover:drop-shadow-lg md:px-10"
            >
              {t('loginToRegister')}
            </button>
            {event.pricingPlan?.hasGroupDiscount && !expiredGroupDiscount && (
              <div className="w-full mt-1">
                <Button
                  variant="gradient"
                  sx={{ width: '100%' }}
                  onClick={() =>
                    router.push(
                      `${locale}/auth/signin?callbackUrl=${locale}${router.asPath}`,
                    )
                  }
                  style={{
                    background:
                      'radial-gradient(circle, rgba(170,119,28,1) 0%, rgba(253,187,45,1) 100%)',
                  }}
                >
                  <span className="font-bold text-lg">
                    {t('CreateGroupDiscount', {
                      x: event.pricingPlan?.groupDiscountMinNumberOfRegistrants,
                    })}
                  </span>
                </Button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default EventPagePricing
